import NewsServer from "../../server/news";
import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "..";
import OutputNewsSummary, {
  RequestNewsCount,
  RequestNewsList,
} from "../../dtos/news/summary";
import OutputNewsDetail, {
  RequestNewsDetailByName,
} from "../../dtos/news/detail";

class NewsServiceReader extends ServiceReader {
  constructor(protected api: NewsServer) {
    super();
  }

  public async count(searchQuerry?: string): Promise<number> {
    const raw = await this.api.get(new RequestNewsCount(searchQuerry));

    if (typeof raw.count != "number")
      throw new TypeError("News count is not a number.");

    return raw.count;
  }

  public async list(
    pageNumber?: number,
    pageSize?: number,
    searchQuerry?: string
  ): Promise<OutputNewsSummary[]> {
    const raw = await this.api.get(
      new RequestNewsList(pageNumber, pageSize, searchQuerry)
    );

    if (!Array.isArray(raw)) throw new TypeError("News list is not an array.");

    return raw.map((value) => OutputNewsSummary.convert(value));
  }

  public async detail(newsName: string): Promise<OutputNewsDetail> {
    const raw = await this.api.get(new RequestNewsDetailByName(newsName));
    return OutputNewsDetail.convert(raw);
  }
}

class NewsServiceCreator extends ServiceCreator {}
class NewsServiceUpdater extends ServiceUpdater {}
class NewsServiceDeleter extends ServiceDeleter {}

export default class NewsService extends Service {
  constructor() {
    super(new NewsServer());
  }

  public get read(): NewsServiceReader {
    return new NewsServiceReader(this.api as NewsServer);
  }
  public get create(): ServiceCreator {
    return new NewsServiceCreator();
  }
  public get update(): ServiceUpdater {
    return new NewsServiceUpdater();
  }
  public get delete(): ServiceDeleter {
    return new NewsServiceDeleter();
  }
}
